import { ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const FloatingBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on home page or auth page
  if (location.pathname === "/" || location.pathname === "/auth") {
    return null;
  }

  return (
    <button
      onClick={() => navigate(-1)}
      className="fixed top-[4.5rem] left-3 z-40 h-9 w-9 rounded-full bg-background/80 backdrop-blur border border-border/50 shadow-md flex items-center justify-center hover:bg-background transition-colors"
      aria-label="Go back"
    >
      <ArrowLeft className="h-5 w-5 text-foreground" />
    </button>
  );
};

export default FloatingBackButton;
